// Enemies that reach the ground destroy the structure they were aimed at (matched
// by x position) and detonate. A hit on an already-dead structure just detonates.

import type { EnemyMissile, Explosion } from '../state/types';
import type { ResolveGroundImpacts } from './contracts';
import { mapBases, mapCities } from '../state/update';
import { createExplosion } from './explosions';
import { GROUND_Y } from '../constants';

const sameColumn = (ax: number, bx: number): boolean => Math.abs(ax - bx) < 1;

export const resolveGroundImpacts: ResolveGroundImpacts = (state) => {
  if (state.enemyMissiles.length === 0) return state;

  let cities = state.cities;
  let bases = state.bases;
  let nextId = state.nextEntityId;
  const explosions: Explosion[] = [...state.explosions];
  const survivors: EnemyMissile[] = [];

  for (const e of state.enemyMissiles) {
    if (e.pos.y >= GROUND_Y) {
      cities = mapCities(cities, (c) =>
        c.alive && sameColumn(c.pos.x, e.target.x) ? { ...c, alive: false } : c,
      );
      bases = mapBases(bases, (b) =>
        b.alive && sameColumn(b.pos.x, e.target.x)
          ? { ...b, alive: false, ammo: 0 }
          : b,
      );
      explosions.push(createExplosion(nextId++, { x: e.pos.x, y: GROUND_Y }, 'enemy'));
      // enemy consumed
    } else {
      survivors.push(e);
    }
  }

  return {
    ...state,
    cities,
    bases,
    enemyMissiles: survivors,
    explosions,
    nextEntityId: nextId,
  };
};
